import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import NotFound from '../views/sessions/NotFound'
import useAuth from '../hooks/useAuth'
import { useFetchInterval } from '../hooks/useFetchInterval'
import { usePrevious } from '../hooks/usePrevious'

const AuthGuard = ({ children }) => {
	const { isAuthenticated } = useAuth()

	const redirect = useNavigate()
	let authenticated = isAuthenticated

	useEffect(() => !authenticated && redirect('/session/signin'), [authenticated, redirect])

	useAccessRightsHandler()

	return <>{authenticated ? children : undefined}</>
}

export default AuthGuard

const useAccessRightsHandler = () => {
	const { signinUser, logout, reloadSigninUser } = useAuth()
	const prevSigninUser = usePrevious(signinUser)

	const { clear } = useFetchInterval({ call: reloadSigninUser, timeout: 10000 }) //10 s

	const isChanged = signinUser && prevSigninUser && signinUser?.role !== prevSigninUser?.role

	if (isChanged) {
		clear()
		logout()
	}
}

export const ShowIfRole = ({ role, children }) => {
	const { signinUser } = useAuth()
	const hasAccess = role.includes(signinUser?.role)

	return hasAccess ? children : <NotFound />
}
